<template>
    <div class="count">
        <button @click="numChange('minus')" disabled>-</button>
        <input type="number" disabled v-model="numLocal">
        <button @click="numChange('plus')" disabled>+</button>
    </div>
</template>

<script>
export default {
    name: 'Count',
    props: {
        num: {
            type: Number,
            default: 0,
        },
        minVal: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            numLocal: 0,
        }
    },
    methods: {
        numChange(mode) {
            (mode == 'plus') ? this.numLocal++ : this.numLocal--;
            this.$emit("update:num", this.numLocal);
            this.$emit("update")
        },
    },
    mounted() {
        this.numLocal = this.num
    },
}
</script>
<style lang="scss">
@import "../../scss/base/include";

.count {
    width: 85px;
    border: 1px solid rgba(125, 121, 135, 0.15);
    border-radius: 5px;
    display: flex;
    height: 30px;

    button {
        display: block;
        border: none;
        min-width: 27px;
        max-width: 27px;
        margin: 0;
        background-color: transparent;
        font-size: 16px;
        outline: none;
        cursor: pointer;
        padding: 0;
    }

    input {
        width: 29px;
        padding: 0;
        border: none;
        background-color: transparent;
        text-align: center;
        font-family: inherit;
        font-size: 16px;

        &::-webkit-outer-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        &[type=number] {
            -moz-appearance: textfield;
        }
    }
}
</style>
